import React from "react";
import { useTranslation } from "react-i18next";
import catalogImages from "../../assets/activity_cards/catalogImages";
import { itemMeta } from "./format";
import { Card, Thumb, Body, ItemTitle, ItemDescription, ItemMeta } from "./styles";

/**
 * Un context, material o postura, igual en la ficha y en los selectores:
 * titulo, descripcion e imagen opcionales, y la linea de informacion adicional
 * de su tipo (`kind`: "contexts" | "materials" | "postures").
 *
 * `as` permite que el selector lo pinte como <label> de su casilla.
 */
const CatalogItem = ({ item, kind, selected = false, as, ...rest }) => {
  const { t } = useTranslation();
  const image = catalogImages[item.id];
  const meta = itemMeta(t, kind, item);

  return (
    <Card as={as} $selected={selected} {...rest}>
      {image && <Thumb src={image} alt="" />}
      <Body>
        <ItemTitle>{item.label}</ItemTitle>
        {item.description && <ItemDescription>{item.description}</ItemDescription>}
        {meta && <ItemMeta>{meta}</ItemMeta>}
      </Body>
    </Card>
  );
};

export default CatalogItem;
